module.exports = __webpack_public_path__ + "static/media/Microsoft_SQL_Server_Logo.e5c34f83.svg";